import { __decorate } from "tslib";
import { Injectable } from 'angular-ts-decorators';
var FaqTeasersService = (function () {
    function FaqTeasersService() {
        this.teasersVisible = true;
    }
    FaqTeasersService.$inject = [];
    FaqTeasersService = __decorate([
        Injectable('faqTeasersService')
    ], FaqTeasersService);
    return FaqTeasersService;
}());
export { FaqTeasersService };
